import { BID_OFFSET, DOUBLE, PASS, REDOUBLE, bidLevel, bidStrain, isBid, sameSide, } from './types.js';
export function auctionState(dealer, calls) {
    let lastBid = null;
    let lastBidder = null;
    let doubled = false;
    let redoubled = false;
    let passRun = 0;
    calls.forEach((call, i) => {
        const seat = ((dealer + i) % 4);
        if (call === PASS) {
            passRun++;
        }
        else if (call === DOUBLE) {
            doubled = true;
            passRun = 0;
        }
        else if (call === REDOUBLE) {
            redoubled = true;
            passRun = 0;
        }
        else {
            lastBid = call;
            lastBidder = seat;
            doubled = false;
            redoubled = false;
            passRun = 0;
        }
    });
    const passedOut = lastBid === null && passRun >= 4;
    const isOver = passedOut || (lastBid !== null && passRun >= 3);
    return {
        calls,
        turn: ((dealer + calls.length) % 4),
        isOver,
        passedOut,
        lastBid,
        lastBidder,
        doubled,
        redoubled,
    };
}
/** Boolean mask over the 38 actions for the seat currently to act. */
export function legalCalls(state) {
    const mask = new Array(38).fill(false);
    if (state.isOver)
        return mask;
    mask[PASS] = true;
    for (let call = state.lastBid === null ? BID_OFFSET : state.lastBid + 1; call < 38; call++) {
        mask[call] = true;
    }
    if (state.lastBid !== null && state.lastBidder !== null) {
        const opponentBid = !sameSide(state.lastBidder, state.turn);
        if (!state.doubled && !state.redoubled && opponentBid)
            mask[DOUBLE] = true;
        if (state.doubled && !state.redoubled && !opponentBid)
            mask[REDOUBLE] = true;
    }
    return mask;
}
/**
 * Final contract: declarer is the first player of the winning side who bid
 * the final strain.
 */
export function finalContract(dealer, calls) {
    const state = auctionState(dealer, calls);
    if (!state.isOver || state.passedOut || state.lastBid === null || state.lastBidder === null)
        return null;
    const strain = bidStrain(state.lastBid);
    const side = state.lastBidder % 2;
    let declarer = state.lastBidder;
    for (let i = 0; i < calls.length; i++) {
        const seat = ((dealer + i) % 4);
        if (seat % 2 === side && isBid(calls[i]) && bidStrain(calls[i]) === strain) {
            declarer = seat;
            break;
        }
    }
    return {
        level: bidLevel(state.lastBid),
        strain,
        declarer,
        doubled: state.doubled,
        redoubled: state.redoubled,
    };
}
export function bidCategory(dealer, callsBefore, call) {
    if (call === DOUBLE || call === REDOUBLE)
        return 'double';
    if (call === PASS)
        return 'pass';
    const seat = ((dealer + callsBefore.length) % 4);
    const openerIndex = callsBefore.findIndex(isBid);
    if (openerIndex < 0)
        return 'opening';
    const opener = ((dealer + openerIndex) % 4);
    if (opener === seat)
        return 'rebid';
    // Partner opened → every later bid of ours (responses and responder
    // rebids alike) is a response; opponents opened → overcalls, advances,
    // and later competitive bids all land in the overcall bucket.
    return sameSide(opener, seat) ? 'response' : 'overcall';
}
export function applyCall(dealer, calls, call) {
    const state = auctionState(dealer, calls);
    if (!legalCalls(state)[call]) {
        throw new Error(`illegal call ${call} in auction [${calls.join(',')}]`);
    }
    return [...calls, call];
}
//# sourceMappingURL=auction.js.map